module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Sfondo"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.activeBaseLayer),
      callback: function($$v) {
        _vm.activeBaseLayer = $$v
      },
      expression: "activeBaseLayer"
    }
  }, _vm._l((_vm.baseLayers), function(item) {
    return _vm._c('el-option', {
      key: item.name,
      attrs: {
        "label": item.label,
        "value": item.name
      }
    }, [_vm._c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._c('img', {
      staticClass: "gv-sfondi-icon",
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _vm._c('span', {
      staticClass: "gv-sfondi-label"
    }, [_vm._v(_vm._s(item.label))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a08a3f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseLayerSwitcher.vue
// module id = 887
// module chunks = 39